import attachment from './attachment';
import importModal from './import-modal';
import multipleSaleText from './multiple-sale-text';
import fileUpload from './file-upload';

const components = {
  ...attachment,
  ...importModal,
  ...multipleSaleText,
  ...fileUpload,
};

export default components;
